import type { OrderInfo } from '@@partner:types:app'

import React from 'react'
import { useFetchCalculateRefund } from '@@partner:graphql/query/order/calculateRefund.gql'
import { formatPrice } from '@@partner:helpers/util'

import { Tag } from 'rsuite'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'

export interface RefundDeliveryContentProps {
  order: OrderInfo
}

const RefundDeliveryContent: React.FC<RefundDeliveryContentProps> = ({
  order
}) => {
  const { data, loading, error } = useFetchCalculateRefund({
    refundInfo: {
      orderId: Number(order.id),
      returnDeliveryCost: true,
      refundMethod: 'money'
    }
  })

  const { deliveryTotal = 0 } = data?.refundInfo ?? {}

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        title="Не удалось рассчитать возврат"
        error={error}
      />
    )
  }

  return (
    <div>
      <p>
        Оформить возврат <Tag color="violet">{formatPrice(deliveryTotal)}</Tag>{' '}
        за доставку?
      </p>
    </div>
  )
}

export default RefundDeliveryContent
